import { renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["w3-button w3-section w3-teal w3-ripple", { 'w3-margin-left': _ctx.ml }]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('clickInternal')), ["stop"]))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}